import { useState } from 'react'
import type { User } from '../api/types'
import { TaskList } from '../components/TaskList'

type Status = 'open' | 'done'

/** Every task the officer owns, across contacts, loans and playbooks. Admins can
 *  look at the whole team's list. */
export function Tasks({ user }: { user: User }) {
  const [status, setStatus] = useState<Status>('open')
  const [scope, setScope] = useState<'mine' | 'all'>('mine')

  return (
    <div className="page" style={{ maxWidth: 980 }}>
      <div className="page-head">
        <div>
          <h1 className="h1">Tasks</h1>
          <p className="subline">
            Overdue first, then by due date. Tasks from workflows and messages that couldn't be sent land here too.
          </p>
        </div>
      </div>

      <div className="smartlist">
        <button className={`slchip${status === 'open' ? ' active' : ''}`} onClick={() => setStatus('open')}>Open</button>
        <button className={`slchip${status === 'done' ? ' active' : ''}`} onClick={() => setStatus('done')}>Completed</button>
        {user.is_admin ? (
          <>
            <span style={{ width: 1, background: 'var(--line)', margin: '0 4px' }} />
            <button className={`slchip${scope === 'mine' ? ' active' : ''}`} onClick={() => setScope('mine')}>Mine</button>
            <button className={`slchip${scope === 'all' ? ' active' : ''}`} onClick={() => setScope('all')}>Whole team</button>
          </>
        ) : null}
      </div>

      <section className="card">
        <div className="card-body">
          <TaskList
            scope={scope}
            status={status}
            showRegarding
            allowAdd={status === 'open'}
            emptyText={status === 'open' ? 'Nothing open. Tasks you add on a contact or loan show up here.' : 'No completed tasks yet.'}
          />
        </div>
      </section>
    </div>
  )
}
